export const SUPPORT_EMAIL = 'support@fixdelivered.com'

// Issue #49 - a real customer-facing number, distinct from the plumber-
// outreach number (...7099, see server TWILIO_FROM_NUMBER).
//
// This line is for TEXTS, not calls (issue #79). A call is answered by saying
// so, texting the caller a link to live chat, and taking a voicemail - see
// routes/webhooks.ts's /twilio/customer-voice and /twilio/customer-sms. So
// everywhere the number is shown it is presented as "Text us", never "Call us",
// and it links with sms: rather than tel:. A "Call us now" button on a number
// that cannot take a call just sends people into a dead end.
//
// Use <TextUsLink> (components/TextUsLink.tsx) rather than building the link by
// hand: it opens the messaging app on a phone and the live chat on a laptop,
// where there is nothing to text from.
export const SUPPORT_PHONE_DISPLAY = '07476 999254'
/** E.164. Still the right value for structured data (schema.org telephone). */
export const SUPPORT_PHONE_TEL = '+447476999254'
/** Opens the device's messaging app addressed to the support line. */
export const SUPPORT_SMS_HREF = `sms:${SUPPORT_PHONE_TEL}`
export const SHOW_SUPPORT_PHONE = true

/**
 * Whether tapping an sms: link here will actually open a messaging app.
 *
 * Phones and tablets, yes. A laptop or desktop usually has no handler for
 * sms:, so the click does nothing or throws up an "open with..." prompt, which
 * is a poor first impression for someone mid-emergency. Detected by input
 * type rather than by user agent: a touch-first device with no hover is the
 * thing that can text. When matchMedia is unavailable (server render, older
 * test environments) this answers false, which falls back to live chat - the
 * safe choice, since chat works everywhere.
 */
export function canTextFromThisDevice(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false
  return window.matchMedia('(hover: none) and (pointer: coarse)').matches
}
